import { render } from "./SongsLoader.vue?vue&type=template&id=712dfe4a"
import script from "./SongsLoader.vue?vue&type=script&lang=js"
export * from "./SongsLoader.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__